import React, { useEffect, useState } from 'react';
import api from '../api';
import './estilodash.css';

export default function PlanosAdmin() {
  const [produtosAtivos, setProdutosAtivos] = useState([]);
  const [pacotesAtivos, setPacotesAtivos] = useState([]);
  const [produtosCrud, setProdutosCrud] = useState([]);
  const [form, setForm] = useState({ id: null, codigo: '', nome: '', descricao: '', ativo: 1 });
  const [msg, setMsg] = useState('');

  const carregar = async () => {
    try {
      const [pa, pca, pc] = await Promise.all([
        api.get('/api/produtos-ativos'),
        api.get('/api/pacotes-ativos'),
        api.get('/api/produtos'),
      ]);
      setProdutosAtivos(pa.data || []);
      setPacotesAtivos(pca.data || []);
      setProdutosCrud(pc.data || []);
    } catch (e) {
      console.error(e);
      setMsg('Erro ao carregar catálogo.');
    }
  };
  useEffect(() => { carregar(); }, []);

  const salvar = async (e) => {
    e.preventDefault();
    try {
      if (form.id) await api.put(`/api/produtos/${form.id}`, form);
      else await api.post('/api/produtos', form);
      setMsg('Produto salvo com sucesso.');
      setForm({ id: null, codigo: '', nome: '', descricao: '', ativo: 1 });
      carregar();
    } catch (e) {
      console.error(e);
      setMsg(e.response?.data?.message || 'Erro ao salvar produto.');
    }
  };

  return (
    <div>
      <h2>Catálogo Comercial</h2>
      <p>Produtos, pacotes e tiers do modelo novo. A edição de preços por tier depende das rotas completas do backend; abaixo já fica a visão operacional do catálogo.</p>
      {msg && <p>{msg}</p>}

      <form onSubmit={salvar} className="card-like">
        <div className="form-linha">
          <label>Código
            <input value={form.codigo} onChange={(e) => setForm({ ...form, codigo: e.target.value })} />
          </label>
          <label>Nome
            <input value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} />
          </label>
          <label>Ativo
            <select value={form.ativo} onChange={(e) => setForm({ ...form, ativo: Number(e.target.value) })}>
              <option value={1}>Sim</option>
              <option value={0}>Não</option>
            </select>
          </label>
        </div>
        <label>Descrição
          <textarea value={form.descricao} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
        </label>
        <button type="submit">Salvar produto</button>
      </form>

      <h3 style={{ marginTop: 20 }}>Produtos (cadastro)</h3>
      <table className="clientes-table">
        <thead><tr><th>ID</th><th>Código</th><th>Nome</th><th>Ativo</th><th>Ações</th></tr></thead>
        <tbody>
          {produtosCrud.map(p => (
            <tr key={p.id}>
              <td>{p.id}</td><td>{p.codigo}</td><td>{p.nome}</td><td>{String(p.ativo) === '1' ? 'Sim' : 'Não'}</td>
              <td><button type="button" onClick={() => setForm({ id: p.id, codigo: p.codigo, nome: p.nome, descricao: p.descricao || '', ativo: Number(p.ativo || 0) })}>Editar</button></td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 style={{ marginTop: 20 }}>Produtos ativos com tiers</h3>
      <table className="clientes-table">
        <thead><tr><th>Produto</th><th>Starter</th><th>Trader</th><th>Pro</th></tr></thead>
        <tbody>
          {produtosAtivos.map(p => (
            <tr key={p.id}>
              <td>{p.nome}</td>
              <td>{p.precos?.starter ? `R$ ${Number(p.precos.starter.valor_brl).toFixed(2)} / ${p.precos.starter.slots_inclusos} slots` : '—'}</td>
              <td>{p.precos?.trader ? `R$ ${Number(p.precos.trader.valor_brl).toFixed(2)} / ${p.precos.trader.slots_inclusos} slots` : '—'}</td>
              <td>{p.precos?.pro ? `R$ ${Number(p.precos.pro.valor_brl).toFixed(2)} / ${p.precos.pro.slots_inclusos} slots` : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 style={{ marginTop: 20 }}>Pacotes ativos</h3>
      <table className="clientes-table">
        <thead><tr><th>Pacote</th><th>Descrição</th><th>Starter</th><th>Trader</th><th>Pro</th></tr></thead>
        <tbody>
          {pacotesAtivos.map(p => (
            <tr key={p.id}>
              <td>{p.nome}</td>
              <td>{p.descricao}</td>
              <td>{p.precos?.starter ? `R$ ${Number(p.precos.starter.valor_brl).toFixed(2)}` : '—'}</td>
              <td>{p.precos?.trader ? `R$ ${Number(p.precos.trader.valor_brl).toFixed(2)}` : '—'}</td>
              <td>{p.precos?.pro ? `R$ ${Number(p.precos.pro.valor_brl).toFixed(2)}` : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
